import { render } from "./fastFoodDetail.vue?vue&type=template&id=25af77c8"
import script from "./fastFoodDetail.vue?vue&type=script&lang=js"
export * from "./fastFoodDetail.vue?vue&type=script&lang=js"

import "./fastFoodDetail.vue?vue&type=style&index=0&id=25af77c8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__